<backstage-alert level="warning">
  <h3 i18n>Backstage is currently undergoing scheduled maintenance.</h3>
  <p i18n>
    Some services may be unavailable but should be back soon. Thank you for your patience.
  </p>
</backstage-alert>
